<template>
  <section class="campaigns-table-wrap">
    <div class="top-bar">
      <div class="left-section">
        <span class="back-button" @click="onBackClick">
          <i class="ion-ios-arrow-left"></i> {{$t('CAMPAIGN.ADD.TABLE.BACK')}}
        </span>
        <span class="campaign-name campaign-status" v-if="campaignName"  >
          <p><strong>{{$t('CAMPAIGN.ADD.DETAILS.NAME')}}:</strong> {{campaignName}}</p>
        </span>
        <span v-if="campaignStatus" class="campaign-status">
          <p><strong>{{$t('CAMPAIGN.ADD.DETAILS.STATUS')}}:</strong> {{campaignStatus}}</p>
        </span>
      </div>


<!--      <div class="right-section">-->
<!--        <select v-model="selectedStatus" @change="applyFilter">-->
<!--          <option value="">All</option>-->
<!--          <option value="No Answer">No Answer</option>-->
<!--          <option value="Answered - Success">Answered - Success</option>-->
<!--          <option value="Answered - Fail">Answered - Fail</option>-->
<!--          <option value="pending">Pending</option>-->
<!--        </select>-->
<!--      </div>-->
    </div>

    <!-- Table -->
    <ve-table
      :columns="columns"
      max-height="calc(100vh - 25.4rem)"
      scroll-width="155rem"
      :table-data="filteredTableData"
      :border-around="true"
    />

    <!-- Loader -->
    <div v-if="isLoading" class="campaign--loader">
      <spinner />
      <span>Loading</span>
    </div>
  </section>
</template>


<script>
import { mixin as clickaway } from 'vue-clickaway';
import { VeTable } from 'vue-easytable';
import Spinner from 'shared/components/Spinner.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import { mapGetters } from 'vuex';


export default {
  components: {
    EmptyState,
    Spinner,
    VeTable,
  },
  mixins: [clickaway],
  props: {
    campaignId: {
      type: String,
      default: '',
    },
    campaignName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isLoading: false,
      columns: [
        {
          field: 'first_name',
          key: 'first_name',
          title: "First name",
          align: 'left',
          renderBodyCell: ({ row }) => (
            <div class="text-truncate">
              <span title={row.first_name}>{row.first_name}</span>
            </div>
          ),
        },
        {
          field: 'last_name',
          key: 'last_name',
          title: "Last Name",
          align: 'left',
          renderBodyCell: ({ row }) => (
            <div class="text-truncate">
              <span title={row.last_name}>{row.last_name}</span>
            </div>
          ),
        },
        {
          field: 'phone',
          key: 'phone',
          title: "Phone Number",
          align: 'left',
          renderBodyCell: ({ row }) => (
            <div class="text-truncate">
              <span title={row.phone}>{row.phone}</span>
            </div>
          ),
        },
        {
          field: 'email',
          key: 'email',
          title: "Email",
          align: 'left',
          renderBodyCell: ({ row }) => (
            <div class="text-truncate">
              <span title={row.email}>{row.email}</span>
            </div>
          ),
        },
      ],
      campaignStatus: '',
      leads: [],
    };
  },


  async created() {
    await this.fetchLeads();
  },

  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
    }),
    filteredTableData() {
      // if (this.selectedStatus) {
      //   return this.callResults.filter(result => result.status === this.selectedStatus);
      // }
      return this.leads;
    },
    // tableData() {
    //   if (this.isLoading) {
    //     return [];
    //   }
    //   return this.callResults;
    // },
  },
  methods: {
    onBackClick(){
      this.$emit('close-results')
    },
    async fetchLeads() {
      try {
        this.isLoading = true;

        const leadsPayload = {
          account_id: this.accountId.toString(),
          campaign_id: this.campaignId,
        };
        const response = await this.$store.dispatch('contacts/getLeadsContact', leadsPayload);
        this.leads = response.data.leads_contacts
      } catch (error) {
        console.error('Error fetching campaign results:', error);
      } finally {
        this.isLoading = false;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.campaigns-table-wrap::v-deep {
  .ve-table {
    padding-bottom: var(--space-large);
    thead.ve-table-header .ve-table-header-tr .ve-table-header-th {
      font-size: var(--font-size-mini);
      padding: var(--space-small) var(--space-two);
    }
    tbody.ve-table-body .ve-table-body-tr .ve-table-body-td {
      padding: var(--space-slab) var(--space-two);
    }
  }

  .row--title-block {
    align-items: center;
    display: flex;
    text-align: left;

    .title {
      font-size: var(--font-size-small);
      margin: 0;
      text-transform: capitalize;
    }
  }
  .label {
    padding: var(--space-smaller) var(--space-small);
  }
}

.campaign--loader {
  align-items: center;
  display: flex;
  font-size: var(--font-size-default);
  justify-content: center;
  padding: var(--space-big);
}

.button-wrapper {
  justify-content: space-evenly;
  display: flex;
  flex-direction: row;
  min-width: 20rem;
}

.campaigns-table-wrap {
  .top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
    background-color: white; // Set background to white or transparent

    .left-section {
      display: flex;
      align-items: center;

      .back-button {
        margin-right: 1.5rem;
        cursor: pointer;
        font-weight: bold;
      }

      .campaign-name{
        margin-right: 1.5rem;
      }

      .campaign-status {
        font-size: 1.2rem;

        strong {
          font-weight: bold; // Bold for the heading
        }

        span {
          font-weight: lighter; // Lighter for the status value
          margin-left: 0.5rem;
        }
      }
    }

    .right-section {
      select {
        padding: 0.5rem;
        font-size: 1.2rem; // Increase dropdown font size
        margin-right: 2rem; // Add margin from the right side
        min-width: 10rem; // Increase width for better visibility
        border: 1px solid #ccc; // Add border for better separation
      }
    }
  }

  .campaign--loader {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
  }
}


</style>
